import React, { useEffect, useState } from "react";
import { Button, Typography, Card, Box, Grid, Container, FormControl, Select, CardContent, Chip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import SubjectService from "./Locality/Service/subjectService";
import { Dialog, DialogContent, IconButton, List, ListItem, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
import { Star, CheckBox, FiberManualRecord, FormatListNumbered } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SchoolIcon from '@material-ui/icons/School';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import LinkIcon from '@material-ui/icons/Link';

//  import { useNavigate } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { Collapse } from "@material-ui/core";

import LessonService from "./Locality/Service/lessonService";

import AddClassService from "./Locality/Service/addClassService";
const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 12px',
    borderRadius: 8,
    border: '1px solid #d9dee7',
    backgroundColor: '#f7f9fc',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    userSelect: 'none',
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1769d6',
    border: '1px solid #cfe0fb',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
  },
  filterGrid: {
    margin: 0,
  },
  filterItem: {
    paddingTop: theme.spacing(1),
  },
  searchButton: {
    backgroundColor: "#1769d6",
    color: "white",
    padding: theme.spacing(1, 2.5),
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    "&:hover": {
      backgroundColor: "#125bbd",
    },
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #d9dee7',
  },
  detailTitle: {
    fontWeight: 700,
    color: '#0f2d4d',
    fontSize: '1.3rem',
    marginBottom: theme.spacing(2),
  },
  sectionCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    marginBottom: theme.spacing(2),
    height: '100%',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(1.5),
  },
  sectionIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  sectionTitle: {
    fontWeight: 700,
    color: '#0f2d4d',
    fontSize: '1.02rem',
  },
  bulletText: {
    color: '#46566b',
    fontSize: '0.92rem',
  },
  stepNumber: {
    width: 26,
    height: 26,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 700,
  },
  poiItem: {
    padding: theme.spacing(1.25, 2),
    backgroundColor: '#e6f7ed',
    border: '1px solid #b7e3c8',
    borderRadius: 10,
    color: '#0f2d4d',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
  },
  lessonGrid: {
    marginTop: theme.spacing(2),
  },
  lessonCardItem: {
    marginBottom: theme.spacing(3),
  },
  lessonCard: {
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    transition: "0.3s",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },
  },
  lessonCardContent: {
    padding: theme.spacing(2.5),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  chipWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  lessonTitle: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    lineHeight: 1.3,
  },
  watchVideoBtn: {
    marginTop: theme.spacing(2),
    backgroundColor: "#1769d6",
    color: "white",
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#125bbd",
    },
  },
  resultsSection: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
}));

export default function TeacherLesson(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [lessonList, setLessonList] = useState([]);
  const [dropDownList, setDropDownList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);

  var [classId, setClassId] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedLessonId, setSelectedLessonId] = useState("");
  var [error, setError] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [showlessons, setShowLessons] = useState(false);
  const [tempLessons, setTemplLessons] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [openImage, setOpenImage] = useState(null);
  // ---- Redesigned UI state ----
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);

  const [selectedData, setSelectedData] = useState({
    _id: "",
    lesson: "",
    subjectId: '',
    pointOfInterest: [],
    stepsAndProcedures: [],
    controlOfError: [],
    materialRequired: [],
    objectives: []
  });


  // const navigate = useNavigate();


  useEffect(() => {
    //getLessonList();
    getSubjectList();
    getAddClassList();
    //getLessonLists();
    return () => {
      setLessons([]);
      setSubjectList([]);
      // setLessonss([]);

    }
  }, []);
    const getAddClassList = (event) => {
          const userDetails = JSON.parse(localStorage.getItem("userDetail"));
          AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
              // if (userDetails.role === "TEACHER") {
              //     res = res.filter(res => res._id === userDetails.classId);
              // }
              setAddClassList(res);
              if (userDetails.classId) {
                setClassId(userDetails.classId);
              } else {
                setClassId(""); // No default selection
              }
          }).catch((err) => {
              // setError(err.message);
          });
      }
  const resetSearch = () => {
    setLessons(tempLessons);
    setDropDownList(tempLessons);
    setSelectedSubjectId("");
    setSelectedLessonId("");
  }
  const handleSearch = () => {
    const results = tempLessons.filter((lesson) => {
      const matchesSubject = selectedSubjectId
        ? lesson.subjectId?._id === selectedSubjectId
        : true;

      const matchesLesson = selectedLessonId
        ? lesson._id?.toLowerCase().includes(selectedLessonId.toLowerCase())
        : true;

      return matchesSubject && matchesLesson;
    });
    setShowLessons(true);
    setLessons(results);
  };



  const getSubjectList = (event) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    SubjectService.getAllSubject().then((res) => {

      setSubjectList(res);
    }).catch((err) => {
      // setError(err.message);
    });
  }
  const getLessonList = (subjectId = null, classId = null) => {
    const body = {};
    if (subjectId) {
      body.subjectId = subjectId;
    }
    if (classId) {
      body.classId = classId;
    }

    LessonService.findLessonList(body).then((res) => {
      setLessons(res);
      setTemplLessons(res);
      setDropDownList(res);
    }).catch((err) => {
      setError(err.message);
    });
  }

  const onChangeClass = (subjectId) => {
    setSelectedSubjectId(subjectId);
    
    // Call getLessonList with subjectId when subject changes
    getLessonList(subjectId, classId);


  }

  // const handleLearnMore = () => {
  //   //navigate(`/lessonmore/${lesson._id}`);
  // };
  const handleLearnMore = () => {
    props.history.push('/app/learnmore')
  };
  const activeFilterCount = [classId, selectedSubjectId, selectedLessonId].filter(Boolean).length;
  return (
    <>
      {/* Page header */}
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Lesson Plan</Typography>
          <Typography className={classes.pageSubtitle}>
            Browse lesson plans by class and subject, then open one for full details.
          </Typography>
        </Box>
      </Box>

      {/* Dismissible note */}
      {noteOpen && (
        <Box className={classes.noteBanner}>
          <span className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </span>
          <Box flex={1}>
            <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f2d4d' }}>Note</Typography>
            <Typography variant="body2" style={{ color: '#46566b' }}>
              Choose a class and subject, then click <b>Search</b> to list lessons. Select a lesson card to view its objectives, materials, and steps.
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)} aria-label="dismiss note">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}


      {/* Filters card */}
      <Card className={classes.filterCard} elevation={0}>
        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" style={{ gap: 16 }}>
          <Box
            className={classes.filtersChip}
            onClick={() => setFiltersOpen((o) => !o)}
            role="button"
            tabIndex={0}
          >
            <FilterListIcon fontSize="small" />
            <span>Filters</span>
            <span className={classes.countBadge}>{activeFilterCount}</span>
            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
          </Box>
        </Box>

        <Collapse in={filtersOpen}>
          <Box className={classes.filterGrid} component="div" mt={2}>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
                <Typography className={classes.fieldLabel}>
                  <SchoolIcon style={{ fontSize: 16 }} /> Class
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="classId"
                    onChange={e => { setClassId(e.target.value) }}
                    value={classId}
                  >
                    <MenuItem value=""><em>All Classes</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
                <Typography className={classes.fieldLabel}>
                  <MenuBookIcon style={{ fontSize: 16 }} /> Subject
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="subjectId"
                    value={selectedSubjectId}
                    onChange={(e) => onChangeClass(e.target.value)}
                  >
                    <MenuItem value=""><em>All Subjects</em></MenuItem>
                    {subjectList.map(({ _id, subject }) => (
                      <MenuItem key={_id} value={_id}>{subject}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
                <Typography className={classes.fieldLabel}>
                  <FormatListNumbered style={{ fontSize: 16 }} /> Lesson
                </Typography>
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    displayEmpty
                    name="lessonId"
                    value={selectedLessonId}
                    onChange={(e) => setSelectedLessonId(e.target.value)}
                  >
                    <MenuItem value=""><em>All Lessons</em></MenuItem>
                    {dropDownList.map(({ index, _id, lesson }) => (
                      <MenuItem key={index} value={_id}>{lesson}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
                <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ gap: 10 }}>
                  <Button className={classes.resetBtn} variant="outlined" onClick={resetSearch}>
                    Reset
                  </Button>
                  <Button
                    className={classes.searchButton}
                    type="button"
                    onClick={handleSearch}
                    variant="contained"
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Collapse>
      </Card>

      <Container sx={{ py: 5 }}>



        <Grid container spacing={4} className={classes.lessonGrid}>
          {showlessons && lessons
            .filter((lesson) =>
              lesson.lesson.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((lesson) => {
              const {
                _id,
                images,
                lesson: title,
                objectives,
                video,
                subjectId,
                classId,
                remarks,
                materialRequired
              } = lesson;
              const isSelected = selectedData._id === _id;

              return (
                <Grid item xs={12} sm={6} md={4} key={_id} className={classes.lessonCardItem}>
                  <Card
                    className={classes.lessonCard}
                    onClick={() => setSelectedData(lesson)}
                    style={{
                      boxShadow: isSelected ? '0 6px 20px rgba(23,105,214,0.22)' : undefined,
                      border: isSelected ? '2px solid #1769d6' : '1px solid #e6eaf0',
                      borderRadius: 14,
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#eef4ff' : '#fff',
                    }}
                  >
                    <CardContent className={classes.lessonCardContent}>
                      <Box className={classes.chipWrapper}>
                        <Chip
                          label={classId?.className || "N/A"}
                          color="primary"
                          size="small"
                        />
                        <Chip
                          label={subjectId?.subject || "N/A"}
                          size="small"
                          style={{
                            backgroundColor: '#e3f2fd',
                            color: '#0d47a1',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                          }}
                          icon={<span role="img" aria-label="subject">📚</span>}
                        />
                      </Box>

                      <Typography variant="h6" className={classes.lessonTitle}>
                        {title.toUpperCase() || "Untitled Lesson"}
                      </Typography>




                      {video && (
                        <Button
                          className={classes.watchVideoBtn}
                          variant="contained"
                          size="small"
                            href={video}
                            target="_blank"
                            rel="noopener noreferrer"
                          fullWidth
                        >
                          WATCH VIDEO
                        </Button>
                      )}
                    </CardContent>
                  </Card>

                </Grid>
              );
            })}
        </Grid>
        <Box py={2}>
          {selectedData._id ? <>
            <Typography className={classes.detailTitle}>{selectedData?.lesson?.toUpperCase()}</Typography>
            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#eef4ff', color: '#1769d6' }}>
                    <TrackChangesIcon fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Objectives / Aims</Typography>
                </Box>
                <List dense>
                  {selectedData.objectives.map((step, index) => (
                    <ListItem key={index} alignItems="flex-start" disableGutters>
                      <ListItemIcon style={{ minWidth: 28 }}>
                        <FiberManualRecord style={{ fontSize: 11, color: '#1769d6' }} />
                      </ListItemIcon>
                      <ListItemText primary={step} primaryTypographyProps={{ className: classes.bulletText }} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>

            </Card>


            <Grid container spacing={2}>
              {/* Materials Section */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard} elevation={0}>
                  <CardContent>
                    <Box className={classes.sectionHeader}>
                      <span className={classes.sectionIcon} style={{ backgroundColor: '#e6f7ed', color: '#1a9b54' }}>
                        <CheckBox fontSize="small" />
                      </span>
                      <Typography className={classes.sectionTitle}>Materials</Typography>
                    </Box>
                    <List dense>
                      {selectedData.materialRequired.map((step, index) => (
                        <ListItem key={index} disableGutters>
                          <ListItemIcon style={{ minWidth: 32 }}>
                            <CheckBox style={{ color: '#1a9b54' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={step}
                            primaryTypographyProps={{
                              className: classes.bulletText,
                              style: {
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              {/* Point of Interest Section */}
              <Grid item xs={12} md={6}>
                <Card className={classes.sectionCard} elevation={0}>
                  <CardContent>
                    <Box className={classes.sectionHeader}>
                      <span className={classes.sectionIcon} style={{ backgroundColor: '#fff4e5', color: '#e08600' }}>
                        <Star fontSize="small" />
                      </span>
                      <Typography className={classes.sectionTitle}>Point of Interest</Typography>
                    </Box>
                    <Box mt={1} display="flex" flexDirection="column" style={{ gap: 10 }}>
                      {selectedData.pointOfInterest.map((step, index) => (
                        <Box key={index} className={classes.poiItem}>
                          <Typography variant="body2" style={{ color: '#0f2d4d' }}>
                            {step}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>



            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#eef4ff', color: '#1769d6' }}>
                    <FormatListNumbered fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Steps / Presentation / Procedures</Typography>
                </Box>

                <List>
                  {selectedData.stepsAndProcedures.map((step, index) => (
                    <ListItem key={index} alignItems="flex-start" disableGutters>
                      <ListItemIcon style={{ minWidth: 40 }}>
                        <span className={classes.stepNumber}>{index + 1}</span>
                      </ListItemIcon>
                      <ListItemText primary={step} primaryTypographyProps={{ className: classes.bulletText }} />
                    </ListItem>
                  ))}
                </List>

                {/* Image Display (if exists) */}

              </CardContent>
            </Card>
            <Card className={classes.sectionCard} elevation={0}>
              <CardContent>
                <Box className={classes.sectionHeader}>
                  <span className={classes.sectionIcon} style={{ backgroundColor: '#eef4ff', color: '#1769d6' }}>
                    <LinkIcon fontSize="small" />
                  </span>
                  <Typography className={classes.sectionTitle}>Useful Links</Typography>
                </Box>

                {selectedData.images?.length > 0 ? (
                  <Box
                    mt={2}
                    display="flex"
                    flexWrap="wrap"
                    style={{ gap: 16 }}
                    justifyContent="center"
                  >
                    {selectedData.images.map((imgUrl, index) => (
                      <Box key={index} textAlign="center">
                        <img
                          src={imgUrl}
                          alt={`Lesson Visual ${index + 1}`}
                          onClick={() => setOpenImage(imgUrl)}
                          style={{
                            maxWidth: '180px',
                            height: 'auto',
                            borderRadius: '8px',
                            border: '1px solid #e6eaf0',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                            margin: '4px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s',
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" style={{ color: '#9aa6b6' }}>No links available.</Typography>
                )}
              </CardContent>
            </Card>

            {/* Image Zoom Dialog */}
            <Dialog
              open={Boolean(openImage)}
              onClose={() => setOpenImage(null)}
              maxWidth="md"
              fullWidth
            >
              <DialogContent style={{ position: 'relative', padding: 0 }}>
                <IconButton
                  onClick={() => setOpenImage(null)}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <img
                  src={openImage}
                  alt="Zoomed"
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </DialogContent>
            </Dialog>

          </> : ""}

        </Box>
      </Container>

    </>
  );
}
